
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Industries/spa-and-salon-pos-billing-software",
      function () {
        return require("private-next-pages/Industries/spa-and-salon-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Industries/spa-and-salon-pos-billing-software"])
      });
    }
  